export default "__VITE_ASSET__BOO_S_BO__";